const STORAGE_KEY = 'eclipsera_client_install_id_v1'

/** Persistent per-browser install id — backend derives stable FE: pseudo-MAC from `x-device-id`. */
export function getOrCreateClientInstallId(): string {
  if (typeof window === 'undefined') return ''
  try {
    const existing = localStorage.getItem(STORAGE_KEY)
    if (existing && existing.trim().length >= 8) {
      return existing.trim()
    }
    const id =
      typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
        ? crypto.randomUUID()
        : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 26)}`
    localStorage.setItem(STORAGE_KEY, id)
    return id
  } catch {
    return ''
  }
}
